export const COL_1_LINKS = [
  {
    name: "Steps to Uni",
    url: "https://www.uac.edu.au/future-applicants/year-10-students"
  },
  {
    name: "What is the ATAR?",
    url: "https://www.uac.edu.au/future-applicants/atar"
  },
  {
    name: "University and college profiles",
    url: "https://www.uac.edu.au/future-applicants/institutions"
  },
  {
    name: "Privacy and Legal",
    url: "https://www.uac.edu.au/about/privacy-legal"
  }
];

export const COL_2_LINKS = [
  // {
  //   name: "Download iOS App",
  //   url: "https://itunes.apple.com/au/app/my-uac/id1057927265"
  // },
  // {
  //   name: "Download Android App",
  //   url: "https://play.google.com/store/apps/details?id=au.edu.uac.uapply"
  // },

];

export const SOCIAL_LINKS = [
  {
    name: "facebook",
    icon: "fab fa-facebook-f",
    url: "https://www.facebook.com/uacinfo/"
  },
  // {
  //   name: "twitter",
  //   icon: "fab fa-twitter",
  //   url: "https://twitter.com/UACinfo/"
  // },
  {
    name: "instagram",
    icon: "fab fa-instagram",
    url: "https://www.instagram.com/uacinfo/"
  },
  // {
  //   name: "snapchat",
  //   icon: "fab fa-snapchat",
  //   url: "https://www.snapchat.com/add/uacinfo"
  // },
  {
    name: "youtube",
    icon: "fab fa-youtube",
    url: "https://www.youtube.com/user/UACinfo/"
  }
];
